/* Victoria London — product-card quick add.
   Single-variant products add straight to the bag via /cart/add.js;
   multi-variant cards fall through to the product page (anchor default). */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vl-qa[data-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('vl-qa--busy')) return;
    btn.classList.add('vl-qa--busy');
    var label = btn.textContent;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(btn.getAttribute('data-variant')), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.classList.add('vl-qa--added');
      btn.textContent = 'Added to Bag';
      var cart = document.querySelector('.cart.utils__item');
      if (cart) cart.classList.add('cart--show-indicator');
      if (window.vlCartDrawer) window.vlCartDrawer.open();
      setTimeout(function () {
        btn.classList.remove('vl-qa--added', 'vl-qa--busy');
        btn.textContent = label;
      }, 2000);
    }).catch(function () {
      window.location.href = btn.getAttribute('data-url') || '/cart';
    });
  });
})();
